var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2803 0.96967C10.1397 0.829018 9.94891 0.75 9.75 0.75H4.5C3.25736 0.75 2.25 1.75736 2.25 3V15C2.25 16.2426 3.25736 17.25 4.5 17.25H13.5C14.7426 17.25 15.75 16.2426 15.75 15V6.75C15.75 6.55109 15.671 6.36032 15.5303 6.21967L10.2803 0.96967ZM4.5 2.25H9.43934L14.25 7.06066V15C14.25 15.4142 13.9142 15.75 13.5 15.75H4.5C4.08579 15.75 3.75 15.4142 3.75 15V3C3.75 2.58579 4.08579 2.25 4.5 2.25Z",
    fill: "#00206E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.5C10.5 1.08579 10.1642 0.75 9.75 0.75C9.33579 0.75 9 1.08579 9 1.5V6.75C9 7.16421 9.33579 7.5 9.75 7.5H15C15.4142 7.5 15.75 7.16421 15.75 6.75C15.75 6.33579 15.4142 6 15 6H10.5V1.5Z",
    fill: "#00206E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc-icon.fef5efa6567e648a40250e5b195dc9ea.svg";
export { ForwardRef as ReactComponent };